export default "/images/trending-down.svg?9044a5caa30decdb7c16560a05dce8be";